;(function () {
  'use strict'

  angular.module('common.services').factory('organizationFactory', [
    '$http',
    '$filter',
    '$localStorage',
    function ($http, $filter, $localStorage) {
      var list
      this.list = []
      this.findItemById = function (id) {
        var returnValue = {
          status: 0
        }
        var item = $filter('filter')(this.list, { id: id })
        if (item.length > 0) {
          returnValue.status = 1
          returnValue.item = item[0]
          returnValue.index = this.list.indexOf(returnValue.item)
        }
        return returnValue
      }
      this.addOrUpdateItem = function (item) {
        var itemData = this.findItemById(item.id)
        if (itemData.status == 1) {
          this.list[itemData.index] = item
        } else {
          this.list.push(item)
        }
      }
      this.deleteItemById = function (id) {
        var itemData = this.findItemById(id)
        if (itemData.status == 1) {
          var index = itemData.index
          this.list.splice(index, 1)
        }
      }

      this.getOrganization = getOrganization

      function getOrganization (id) {
        return $http({
          method: 'GET',
          url: USER_BASEURL + '/organization/' + id
        })
      }

      return this
    }
  ])
})()
